import React, { useEffect, useState }  from 'react';
import HomeComp from '../../components/Home/homeComp';
import HeaderComp from '../../components/Header/HeaderComp';
import SidebarComp from '../../components/Sidebar/SidebarComp';
import { UserDetails } from '../../redux/actions/authActions';
import { useDispatch } from 'react-redux';
import PageLoaderComp from '../../components/pageLoaderComp';
function Home() {
    const dispatch = useDispatch();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };    
    useEffect(() => {
        setPageLoading(true);
        // dispatch(UserDetails());
        setTimeout(() => {
            setPageLoading(false);
        }, 1000);
    }, []);
    return <>
        {pageLoading ?
        <PageLoaderComp />
        : <>
            <HeaderComp toggleSidebar={toggleSidebar} />
            <SidebarComp open={sidebarOpen} toggleSidebar={toggleSidebar} />
            <HomeComp />
        </>
        }
        
    </>;
}

export default Home;
